import React from 'react'
import { Box, TablePagination, Pagination, useMediaQuery } from "@mui/material";
import { useTheme } from '@emotion/react';

const CustomPagination = ({ count, page, onPageChange, rowsPerPage, onRowsPerPageChange, rowsPerPageOptions }) => {
    const theme = useTheme()
    const isMobile = useMediaQuery('(max-width:600px)');
    
    // Calculate total pages for Pagination component
    const totalPages = Math.ceil(count / rowsPerPage) || 1;
    
    // TablePagination uses 0-indexed page, Pagination uses 1-indexed
    // Ensure page is within valid range for TablePagination
    const tablePaginationPage = count > 0 ? Math.max(0, page - 1) : 0;
    
    return (
        <Box 
            display={'flex'} 
            alignItems={'center'} 
            justifyContent={{ xs: 'center', sm: 'space-between' }} 
            flexWrap={'wrap'}
            gap={1}
            py={1}
        >
            <TablePagination
                component="div"
                rowsPerPageOptions={rowsPerPageOptions}
                count={count}
                page={tablePaginationPage}
                onPageChange={(e, newPage) => onPageChange(e, newPage + 1)}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={onRowsPerPageChange}
                nextIconButtonProps={{ style: { display: "none" } }}
                backIconButtonProps={{ style: { display: "none" } }}
                labelDisplayedRows={() => (``)}
                sx={{
                    '& .MuiTablePagination-selectLabel': {
                        display: { xs: 'none', sm: 'block' },
                    },
                    '& .MuiTablePagination-displayedRows': {
                        display: { xs: 'none', sm: 'block' },
                    },
                }}
            />
            <Pagination 
                variant="outlined" 
                count={totalPages} 
                page={page} 
                onChange={onPageChange} 
                size={isMobile ? 'small' : 'small'}
                color="primary" 
                shape="rounded" 
                siblingCount={isMobile ? 0 : 1}
                boundaryCount={isMobile ? 1 : 1}
                sx={{ 
                    marginRight: { xs: '0', sm: '20px !important' },
                    '& .MuiPaginationItem-root': {
                        minWidth: { xs: '28px', sm: '32px' },
                        height: { xs: '28px', sm: '32px' },
                        fontSize: { xs: '12px', sm: '14px' },
                    }
                }} 
            />
        </Box>
    )
}

export default CustomPagination